module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"billingInfo":"Dati di fatturazione","taxableAmount":"Imponibile","vat":"IVA","paypalNote":"Sul circuito di PayPal puoi pagare anche con la tua carta di credito."},"en":{"billingInfo":"Billing information","taxableAmount":"Taxable Amount","vat":"VAT","paypalNote":"Using the PayPal circuit you can pay using your credit card"}}')
  delete Component.options._Ctor
}
